import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { Button, Input } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { ModalActions } from 'components/Modal';
import { stripTags, decodeHTMLEntity } from 'Workspace/Publications/utils';
import { invalidAuthorNames } from 'Workspace/Publications/utils/constants';
import { publishFormat } from '../../utils/constants';

import messages from './messages';
import {
  AddModalWrapper, FormField, ModalTitle,
} from './styles';

function PublishAddModel({ onDismiss, addToPublication, activity, outputType }) {
  const { title: activityTitle = '', author: activityAuthor = '' } = activity.configFields;
  const [title, setTitle] = useState(activityTitle);
  const [author, setAuthor] = useState(stripTags(activityAuthor));
  const useAuthor = (outputType === publishFormat.EPUB || outputType === publishFormat.CHANNEL_PARTNER || outputType === publishFormat.PEARSON_PLUS_TEST || outputType === publishFormat.PEARSON_PLUS);
  const authorFeedback = useAuthor ? invalidAuthorNames.includes(author.toLowerCase()) : false;

  const updateAuthor = (event) => {
    setAuthor(event.currentTarget.value);
  };

  const updateTitle = (event) => {
    setTitle(event.currentTarget.value);
  };

  const onAdd = () => {
    addToPublication({
      activity,
      author,
      title,
    });
  };

  return (
    <AddModalWrapper>
      <ModalTitle>{intl.formatMessage(messages.contentInfoTitle)}</ModalTitle>
      <FormField>
        <Input label={intl.formatMessage(messages.bronteProjectName)} value={title} onChange={updateTitle} />
      </FormField>
      { useAuthor && 
        <FormField>
          <Input disabled label={intl.formatMessage(messages.author)} value={decodeHTMLEntity(author)} onChange={updateAuthor} feedback={authorFeedback ? intl.formatMessage(messages.authorFeedback) : ''}/>
        </FormField>
      }
      <ModalActions>
        <Button grey onClick={onDismiss}>{intl.formatMessage(messages.cancelButton)}</Button>
        <Button primary disabled={authorFeedback} onClick={onAdd}>{intl.formatMessage(messages.addButton)}</Button>
      </ModalActions>
    </AddModalWrapper>
  );
}

PublishAddModel.propTypes = {
  activity: PropTypes.object,
  onDismiss: PropTypes.func,
  addToPublication: PropTypes.func,
};

export default withTheme(PublishAddModel);
